import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class FeaturedHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            content:this.props.content, 
            image:encodeURI(this.props.content[3].image)
        }
        

    }

    componentDidMount()
    {  
         
        if(this.props.content && this.state.loading === 1)
        {
             this.setState({loading:0});     
        }
        
       
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

        <div class="ongoing-area bg-dark text-light">
        <div class="container-full">
            <div class="row">
                <div class="og-items">
                     
                    <div class="item">
                        <div class="col-md-6 thumb bg-cover" style={{backgroundImage: `url(${this.state.image})`}} ></div>
                        <div class="col-md-6 info">
                        <h4 className="colorwhite">{this.state.content[3].title}</h4>
                          
                            <ul class="nav nav-pills">
                                <li class="equal-height active">
                                    <Link data-toggle="tab" to="#tab1" aria-expanded="true">
                                        <span>{this.state.content[3]['subtitle']}</span>
                                    </Link>
                                </li>
                                <li class="equal-height">
                                    <Link data-toggle="tab" to="#tab2" aria-expanded="false">
                                        <span>{this.state.content[4]['subtitle']}</span>
                                    </Link>
                                </li>
                                
                            </ul>
                            
                            <div class="tab-content tab-content-info">
                                
                                <div id="tab1" class="tab-pane fade active in">
                                    <div class="info title">
                                        
                                        <h2>{this.state.content[3]['subtitle']}</h2>
                                        <div className="colorwhite" dangerouslySetInnerHTML={{ __html: this.state.content[3].description }} />   
                                        <Link to="/" class="btn btn-light border btn-md" data-animation="animated slideInUp">See our Products</Link>
                                    </div>
                                </div>
                                
                                <div id="tab2" class="tab-pane fade">
                                    <div class="info title">
                                       
                                    <h2>{this.state.content[4]['subtitle']}</h2>
                                    <div className="colorwhite" dangerouslySetInnerHTML={{ __html: this.state.content[4].description }} />   
                                        <Link to="/" class="btn btn-light border btn-md" data-animation="animated slideInUp">See our Products</Link>
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                     
                </div>
            </div>
        </div>
    </div> 
       
    );
}

}

export default FeaturedHome;